import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import { IMenuItem } from '@/helpers/interfaces/common.interface';

type CrmType = 'amocrm' | 'bitrix';

// salon_id is only set for the YClients widget (it has no type of its own)
export const crmInfoAtom = atom<{ type: CrmType, entity_id: string, entity_type: string, account: string, salon_id?: string } | null>(null);

export const lastSmsSendedAtom = atom<Date | null>(null);

type Layout = 'grid' | 'list';
export const layoutAtom = atom<Layout>('grid');

export const timezonesAtom = atom<{ utc: string, city: string }[]>([]);

export const mainDataAtom = atom<{
  company?: {
    [key: string]: IMenuItem
  },
  topPanel?: {
    left: IMenuItem[],
    right: IMenuItem[]
  },
  header?: {
    solutions: (IMenuItem & { isNew?: boolean })[],
    templates: IMenuItem[],
    categories: IMenuItem[],
    integrations: IMenuItem[],
    useful: IMenuItem[],
    apps: {
      name: string,
      qrImage: string,
      image: string,
      imageWhite: string,
      icon: string,
      href: string,
    }[],
  },
  footer?: {
    id: string,
    name: string,
    items: (IMenuItem & { title: string })[]
  }[],
  homepageMenu?: (IMenuItem & { id: string })[],
}>({});

export const mainCompanyDataAtom = selectAtom(mainDataAtom, slice => slice?.company || {});
export const topPanelAtom = selectAtom(mainDataAtom, slice => slice?.topPanel || { left: [], right: [] });
export const headerAtom = selectAtom(mainDataAtom, slice => slice?.header || { solutions: [], templates: [], categories: [], integrations: [], useful: [], apps: [] });
export const footerDataAtom = selectAtom(mainDataAtom, slice => slice?.footer || []);
export const homepageMenuAtom = selectAtom(mainDataAtom, slice => slice?.homepageMenu || []);
export const solutionsAtom = selectAtom(mainDataAtom, slice => slice?.header?.solutions || []);
